import type { InputHTMLAttributes } from "react";

type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "className"> & {
  className?: string | undefined;
  error?: string | undefined;
};

export function Input({ className, error, id, ...props }: InputProps): JSX.Element {
  const errorId = id === undefined ? undefined : `${id}-error`;
  return (
    <div className="w-full">
      <input
        id={id}
        aria-invalid={error !== undefined}
        aria-describedby={errorId}
        className={cx(base, error !== undefined && "border-danger focus:border-danger", className)}
        {...props}
      />
      {error !== undefined && (
        <p id={errorId} className="mt-1 text-xs text-danger">
          {error}
        </p>
      )}
    </div>
  );
}

const base =
  "h-11 w-full rounded-md border border-border bg-surface px-3 text-sm text-text-primary placeholder:text-text-tertiary shadow-soft transition focus:border-primary focus:outline-none focus:ring-2 focus:ring-[var(--color-focus-ring)] disabled:cursor-not-allowed disabled:opacity-60";

function cx(...classes: Array<string | false | undefined>): string {
  return classes.filter(Boolean).join(" ");
}
